import { Axis } from '@visx/xychart';

import { useTickValues } from './useTickValues';
import { type AxisProps, DEFAULT_X_TICKS } from './utils';

import type { TickLabelProps } from '@visx/axis';

export const XAxis = <T,>({ tickFormat, numTicks = DEFAULT_X_TICKS }: AxisProps<T>) => {
  const { xTickValues } = useTickValues({ numXTicks: numTicks });
  const lastIndex = xTickValues ? xTickValues.length - 1 : -1;

  const tickLabelProps: TickLabelProps<T> = (_value, index) => ({
    dy: 4,
    ...(index === 0 && { textAnchor: 'start' as const }),
    ...(index === lastIndex && { textAnchor: 'end' as const }),
  });

  return (
    <Axis
      hideAxisLine={true}
      orientation="bottom"
      tickValues={xTickValues}
      tickFormat={tickFormat}
      hideTicks={true}
      tickLabelProps={tickLabelProps}
    />
  );
};
